import { render } from "./_InputText.vue?vue&type=template&id=28d4744c"
import script from "./_InputText.vue?vue&type=script&lang=js"
export * from "./_InputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/FormElements/_InputText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d4744c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d4744c', __exports__)) {
    api.reload('28d4744c', __exports__)
  }
  
  module.hot.accept("./_InputText.vue?vue&type=template&id=28d4744c", () => {
    api.rerender('28d4744c', render)
  })

}


export default __exports__